import { render, staticRenderFns } from "./AllotOrder.vue?vue&type=template&id=64ac077c&"
import script from "./AllotOrder.vue?vue&type=script&lang=js&"
export * from "./AllotOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports